import { Component, OnInit, ViewChild, ComponentFactoryResolver } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EbComponentHostDirective } from "../../directives/ebcomponent-host.directive";

import { EntityBuilderItem } from "../../models/entity-builder-item";

import { ComponentService } from '../../services/component-service.service';
import { SidePanelBase } from '../../../common/components/side-panel-base.class';
import { SidePanelService } from "../../../common/services/side-panel.service";
import { isEmpty } from "../../../common/models/data-manipulation-functions";
//

@Component({
    selector: 'edit-entity',
    templateUrl: './edit-entity.component.html',
    standalone: false
})
export class EditEntityComponent extends SidePanelBase implements OnInit {
    static componentName = 'EditEntityComponent';



    formComponent: FormGroup;

    get editing() {
        return this.componentData;
    }

    @ViewChild(EbComponentHostDirective, { static: true }) ebComponentHost: EbComponentHostDirective;

    constructor(
        public componentFactoryResolver: ComponentFactoryResolver,
        public componentService: ComponentService,
        public ebComponentItem: EntityBuilderItem,
        public sidePanelService: SidePanelService
    ) {
		super();
		this.componentData = {
			name: "", data: {}, parent: ""
		};
    }

    ngOnInit(): void {
        this.formComponent = new FormGroup({
            'name': new FormControl(this.editing.name, [
                Validators.required
            ]),
        });

        this.updateSidePanel(this.editing);
    }

    updateSidePanel(editing: any) {
        this.formComponent = new FormGroup({
            'name': new FormControl(editing.name),
        });
        this.formComponent.setValue({ name: editing.name });
        this.loadComponent(editing.name, editing.data, editing.parent, editing.newItem);
    }

    loadComponent(propName: string, prop, parent?, newItem?) {
     //   let newComponent = new EbComponentItem(this.getComponent(prop), prop);
        if(!prop.type) {
            prop.type = "object";
        }

        this.ebComponentItem.createComponent(prop, true, prop);
        let componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.ebComponentItem.component);
        let viewContainerRef = this.ebComponentHost.viewContainerRef;

		//let componentRef = viewContainerRef.createComponent(componentFactory);
		let componentRef = viewContainerRef.createComponent(this.ebComponentItem.component);
        (<IFormComponent>componentRef.instance).data = this.ebComponentItem.data;
        (<IFormComponent>componentRef.instance).title = propName;
        (<IFormComponent>componentRef.instance).parent = parent;
        (<IFormComponent>componentRef.instance).newItem = newItem;
        (<IFormComponent>componentRef.instance).formComponent = this.getFormComponent(this.ebComponentItem.data, this.formComponent);
    }

    cancel(): void {
        this.sidePanelService.toggleSidePanel(false);
        this.formComponent.reset();
        this.ebComponentHost.viewContainerRef.clear();
    }

    save(): void {
        this.setEditing();
        if (this.editing.newItem) {
            this.saveMethod.emit({type: "add", data: this.editing });
            //this.saveAdd.emit(this.editing);
        } else {
            //this.saveEdit.emit(this.editing);
            this.saveMethod.emit({type: "edit", data: this.editing});
        }

        this.formComponent.reset();
        this.ebComponentHost.viewContainerRef.clear();

        this.sidePanelService.toggleSidePanel(false);
    }

    getFormComponent(prop: any, formComponent: FormGroup): any {
        let propType:any;
        if (prop.type instanceof Array) {
            propType = prop.type[0];
        } else {
            propType = prop.type;
        }
        switch (propType) {
            case "string":
                {
                    formComponent.addControl("allowEdit", new FormControl(prop.allowEdit));
                    formComponent.addControl("isOrganizationId", new FormControl(prop.isOrganizationId));
                    formComponent.addControl("displayName", new FormControl(prop.displayName));

                    if (prop.format) {
                        formComponent.addControl("format", new FormControl(prop.format));                        
                        return formComponent;
                    }                   
                    else {
                        prop.format = "none";
                        formComponent.addControl("format", new FormControl(prop.format));

                        return formComponent;
                    }
                  
                };
            case "boolean":
                formComponent.addControl("allowEdit", new FormControl(prop.allowEdit));
                formComponent.addControl("displayName", new FormControl(prop.displayName));

                return formComponent;
            case "number":
                {
                    formComponent.addControl("allowEdit", new FormControl(prop.allowEdit));
                    formComponent.addControl("displayName", new FormControl(prop.displayName));
                    formComponent.addControl("numberType", new FormControl(false));
                    return formComponent;
                };
            case "integer":
                {
                    formComponent.addControl("allowEdit", new FormControl(prop.allowEdit));
                    formComponent.addControl("displayName", new FormControl(prop.displayName));
                    formComponent.addControl("numberType", new FormControl(true));
                    return formComponent;
                };
            case "array":
                {
                    if (prop.items.type instanceof Array) {
                        formComponent.addControl("allowNulls", new FormControl(true));
                    } else {
                        formComponent.addControl("allowNulls", new FormControl(false));
                    }
                    formComponent.addControl("itemType", new FormControl(prop.items.type instanceof Array? prop.items.type[0]: prop.items.type));
                    return formComponent;
                };
            case "object":
                {
                    if (!isEmpty(prop.properties)) {
                        const propArray = Object.keys(prop.properties);
                        if (prop.properties[propArray[0]].type instanceof Array) {
                            formComponent.addControl("allowNulls", new FormControl(true));
                        } else {
                            formComponent.addControl("allowNulls", new FormControl(false));
                        }
                    } else {
                        formComponent.addControl("allowNulls", new FormControl(false));
                    }
                    formComponent.addControl("itemType", new FormControl(""));
                    return formComponent;
                }
            default:
                return null;
        }
    }

    setEditing(): void {
        let propType: any;
        if (this.editing.data.type instanceof Array) {
            propType = this.editing.data.type[0];
        } else {
            propType = this.editing.data.type;
        }
        switch (propType) {
            case "string":
                {
                    this.editing.data.format = this.formComponent.controls["format"].value;

                    if (this.editing.name !== this.formComponent.controls["name"].value) {
                        this.editing.oldName = this.editing.name;
                        this.editing.name = this.formComponent.controls["name"].value;
                    }

                    this.editing.data.allowEdit = this.formComponent.controls["allowEdit"].value;
                    this.editing.data.displayName = this.formComponent.controls["displayName"].value;  
                    this.editing.data.isOrganizationId = this.formComponent.controls["isOrganizationId"].value;

                    if (this.editing.data.format === "none") {
                        delete this.editing.data.format;
                    }
                    break;
                };
            case "boolean":
                {
                    if (this.editing.name !== this.formComponent.controls["name"].value) {
                        this.editing.oldName = this.editing.name;
                        this.editing.name = this.formComponent.controls["name"].value;
                    }
                    this.editing.data.allowEdit = this.formComponent.controls["allowEdit"].value;
                    this.editing.data.displayName = this.formComponent.controls["displayName"].value;

                    break;
                };
            case "number":
                {
                    if (this.editing.name !== this.formComponent.controls["name"].value) {
                        this.editing.oldName = this.editing.name;
                        this.editing.name = this.formComponent.controls["name"].value;
                    }

                    if (this.formComponent.controls["numberType"].value) {
                        this.editing.data.type = "integer";
                    }
                    this.editing.data.allowEdit = this.formComponent.controls["allowEdit"].value;
                    this.editing.data.displayName = this.formComponent.controls["displayName"].value;

                    break;
                };

            case "integer":
                {
                    if (this.editing.name !== this.formComponent.controls["name"].value) {
                        this.editing.oldName = this.editing.name;
                        this.editing.name = this.formComponent.controls["name"].value;
                    }

                    if (!this.formComponent.controls["numberType"].value) {
                        this.editing.data.type = "number";
                    }
                    this.editing.data.allowEdit = this.formComponent.controls["allowEdit"].value;
                    this.editing.data.displayName = this.formComponent.controls["displayName"].value;

                    break;
                };

            case "array":
                {
                    if (this.editing.newItem) {
                        this.editing.data.items.type = this.formComponent.controls["itemType"].value;
                        break;
                    }

                    if (this.editing.name !== this.formComponent.controls["name"].value) {
                        this.editing.oldName = this.editing.name;
                        this.editing.name = this.formComponent.controls["name"].value;
                    }

                    if (this.formComponent.controls["allowNulls"].value) {
                        this.editing.data.items.type = [this.formComponent.controls["itemType"].value, "null"];
                    } else {
                        this.editing.data.items.type = this.formComponent.controls["itemType"].value;
                    }

                    if (this.formComponent.controls["itemType"].value !== "string") {
                        if (this.editing.data.items.format) {
                            delete this.editing.data.items.format;
                        }
                    }
                    break;
                };

            case "object":
                {

                    if (this.editing.newItem) {
                        this.editing.name = this.formComponent.controls["name"].value;
                        this.editing.data.type = this.formComponent.controls["itemType"].value;
                        break;
                    }

                    if (this.editing.name !== this.formComponent.controls["name"].value) {
                        this.editing.oldName = this.editing.name;
                        this.editing.name = this.formComponent.controls["name"].value;
                    }

                    if (this.formComponent.controls["allowNulls"].value) {
                        Object.keys(this.editing.data.properties).forEach(key => {
                            this.editing.data.properties[key].type = [this.editing.data.properties[key].type, "null"];
                        });
                    } else {
                        Object.keys(this.editing.data.properties).forEach(key => {
                            if (this.editing.data.properties[key].type instanceof Array) {
                                this.editing.data.properties[key].type = this.editing.data.properties[key].type[0];
                            }
                        });
                    }
                    break;
                };

            default:
            {
            };
        }
    }
}

export interface IFormComponent {
    data: any;
    title: string;
    parent?: string;
    formComponent: FormGroup;
    newItem?: boolean;
}

export class ItemType {
    key: string;
    value: string;
}
